import { lazy, Suspense } from 'react';
import { LazyAssetsFallback, type LazyAssetProps } from '@frontend/internal-assets';

const LazyPhonesIllustration = lazy(() => import('./svg-components/phones-illustration'));

const PhonesIllustration = ({ assetsFallbackProps = {}, customFallback, ...rest }: LazyAssetProps) => (
  <Suspense fallback={customFallback || <LazyAssetsFallback {...assetsFallbackProps} />}>
    <LazyPhonesIllustration {...rest} />
  </Suspense>
);

export default PhonesIllustration;
